import dataSources from "dataSources";
import { batch } from "react-redux";
import { STATUS_LOADING } from "common/constants";
import { Operation } from "common/types/store/operation";
import { getResponseError } from "common/utils/index";

import slice from "../reducer/slice";
import { applicationActions } from "entities/application";

const { setUserCards, setUserCardsLoading } = slice.actions;
const { setErrorNotice } = applicationActions;

const operation: Operation = () => async (dispatch: any) => {
  try {
    dispatch(setUserCardsLoading(STATUS_LOADING.load));

    const autosCoordinates =
      await dataSources.userLocation.geUserCurrentLocations();
    const userCards = autosCoordinates.usersLocations.map(
      ({ autoNumber, cardNumber }) => ({ autoNumber, cardNumber })
    );

    batch(() => {
      dispatch(setUserCardsLoading(STATUS_LOADING.done));
      dispatch(setUserCards(userCards));
    });
  } catch (e) {
    const error = await getResponseError(e);
    dispatch(setErrorNotice(error));
    dispatch(setUserCardsLoading(STATUS_LOADING.error));
  }
};

export default operation;
